export default __webpack_public_path__ + "static/smu-a0e7109a1905746ca785fc1e40bf3f8c.png";